import Vue from "vue";
import { UpdateService } from "@/common/api.service";

const initialState = {
  loading: true,
  status: null,
  statusUpgrade: null,
  listUpgradable: null
};

export const state = { ...initialState };

export const actions = {
  startUpdate(context) {
    context.commit("setListUpgradable", null);
    return UpdateService.startUpdate();
  },
  async getStatusUpdate(context) {
    context.commit("setLoading", true);
    const { data } = await UpdateService.getStatusUpdate();
    context.commit("setStatus", data);
    context.commit("setLoading", false);
    return data;
  },
  async getListUpgradable(context) {
    context.commit("setLoading", true);
    const { data } = await UpdateService.getListUpgradable();
    context.commit("setListUpgradable", data.list);
    context.commit("setLoading", false);
    return data;
  },
  async getStatusUpgrade(context) {
    context.commit("setLoading", true);
    const { data } = await UpdateService.getStatusUpgrade();
    if (data.result) {
      console.log(data.result);
      for (let i = 0; i< data.result.length; i++) {
        context.commit("updateUpgradableStatus", {name: data.result[i].name, status:data.result[i].status});
      }
    }
    
    context.commit("setLoading", false);

    return data;
  },
  startUpgrade(context) {
    return UpdateService.startUpgrade();
  },

};


export const mutations = {
  setUpgradable(state, data) {
    state.upgradable = data;
  },
  setStatus(state, data) {
    state.status = data;
  },
  setLoading(state, data) {
    state.loading = data;
  },
  setListUpgradable(state, data) {
    state.listUpgradable = data;
  },
  setStatusUpgrade(state, data) {
    state.statusUpgrade = data;
  },
  updateUpgradableStatus(state, {name, status}) {
    let found = state.listUpgradable.map(item => item.name).indexOf(name);
    if (found >= 0 && status) {
      console.log("Updating upgradable status to " + status);
      state.listUpgradable[found].status = status;
    }
  }
};


export default {
  namespaced: true,
  state,
  actions,
  mutations
};
